module.exports = __webpack_public_path__ + "static/media/demo5.45a358d6.png";